import { render, staticRenderFns } from "./MoleculeItemResource.vue?vue&type=template&id=5894c56b&scoped=true&"
import script from "./MoleculeItemResource.vue?vue&type=script&lang=js&"
export * from "./MoleculeItemResource.vue?vue&type=script&lang=js&"
import style0 from "./MoleculeItemResource.vue?vue&type=style&index=0&id=5894c56b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5894c56b",
  null
  
)

export default component.exports